import { Password } from 'primereact/password';

const BaseInputPassword = (props)=>{
    return <Password {...props}></Password>
}

export default BaseInputPassword;